import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["onClick", "children", "dataContentPiece"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { c as i } from "../clsx-OuTLNxxd.js";
import { useCallback as m } from "react";
import { Icon as _ } from "../Icon/Icon.js";
import { i as l } from "../checks-C6AyTTQ0.js";
const u = "PromoBadges-module_container__VVZsi",
  p = "PromoBadges-module_promo-icon__azH1j",
  f = "PromoBadges-module_inverted__H5Ksc",
  v = "PromoBadges-module_item__yVQbB",
  b = "PromoBadges-module_as-link__TA6Zw",
  x = "PromoBadges-module_container-small__9sTDb",
  n = {
    container: u,
    promoIcon: p,
    inverted: f,
    item: v,
    asLink: b,
    containerSmall: x
  },
  N = _ref => {
    let {
      className: e,
      promos: o,
      onPromoBadgeClicked: a,
      inverted: t = !1,
      variant: c = "normal"
    } = _ref;
    return o.length == 0 ? null : /* @__PURE__ */d("div", {
      className: i(n.container, e, {
        [n.containerSmall]: c == "small"
      }),
      children: [/* @__PURE__ */r(_, {
        name: "promo",
        className: i(n.promoIcon, {
          [n.inverted]: t
        }),
        size: "1x",
        padding: !1
      }), o.map(s => /* @__PURE__ */r(g, {
        promo: s,
        onPromoBadgeClicked: a,
        inverted: t
      }, s.code))]
    });
  },
  g = _ref2 => {
    let {
      promo: e,
      onPromoBadgeClicked: o,
      inverted: a
    } = _ref2;
    const t = m(() => o == null ? void 0 : o(e.code), [o, e.code]);
    return /* @__PURE__ */r(I, {
      className: i(n.item, {
        [n.inverted]: a,
        [n.asLink]: l(o)
      }),
      onClick: o ? t : void 0,
      dataContentPiece: "promo_badge_click__".concat(e.code),
      children: e.title
    }, e.code);
  },
  I = _ref3 => {
    let {
        onClick: e,
        children: o,
        dataContentPiece: a
      } = _ref3,
      t = _objectWithoutProperties(_ref3, _excluded);
    const c = m(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    s => {
      e && (s.code == "Space" || s.code == "Enter") && e(s);
    }, [e]);
    return l(e) ? /* @__PURE__ */r("div", _objectSpread(_objectSpread({}, t), {}, {
      onClick: e,
      onKeyDown: c,
      tabIndex: 0,
      role: "button",
      "aria-pressed": "false",
      style: {
        cursor: "pointer"
      },
      "data-content-piece": a,
      children: o
    })) : /* @__PURE__ */r("div", _objectSpread(_objectSpread({}, t), {}, {
      children: o
    }));
  };
export { N as PromoBadges };